import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { voicesTypeControl } from '../../../types/audioType';
import { sub2_act1_01, sub2_act1_02, sub2_act1_03, sub2_act1_04, sub2_act1_05 } from '../../../assets/tema8';
import { ModalInfoTextV3 } from '../../../components/common/ModalInfoTextV3';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	win: 13
};

export const Theme8SubtopicTwoActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema8.activities.subtema2], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 8 sub 2 act 1");
			ObserverEmitter.emit(EVENTS.tema8.topic2.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad1.sub2a1a01)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema8.topic2.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Actividad 1: Regla de Oro.' />
					<DialogBarNew
						dialog={`A continuación, te hablare sobre situaciones de riesgos en Tienda.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2. Situaciones de riesgo"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad1.sub2a1a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Una situación de riesgo es cualquier evento en donde existe la posibilidad de que sufras algún daño físico.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad1.sub2a1a03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`En OXXO, nos preocupamos por la integridad de cada Colaborador o Colaboradora. Es importante que siempre estés atenta/o a cualquier acción criminal que se presente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad1.sub2a1a04)
							ObserverEmitter.emit(EVENTS.characterAnimations.pensativo);
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Todo empleado de Tienda sabe que prevenir es tomar acciones que ayuden a reducir los riesgos de un percance, como asaltos, extorsiones, fraudes, agresiones o amenazas.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad1.sub2a1a05)
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						dialog={`Ante situaciones de riesgo, debes seguir la REGLA DE ORO: Mantén la calma y asume una actitud pasiva para que el incidente termine lo antes posible y nadie salga lastimado.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad1.sub2a1a06)
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`Recuerda siempre que TU INTEGRIDAD ES LO MÁS IMPORTANTE. Por ello, ten presentes los pasos de la REGLA DE ORO.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<ModalInfoTextV3
						title='Mantén la calma'
						description='Respira profundo y sé consciente de la situación. Es importante hacer sentir al delincuente que tiene el control y no gritar o alterarse, ya que de lo contrario podría hacernos daño.'
						url={sub2_act1_01}
						callback={() => {
							setUiToShow(steps.dialogEight);
						}}
					/>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<ModalInfoTextV3
						title='No opongas resistencia'
						description='No expongas tu integridad, escucha la petición del delincuente y entrega lo que solicite. No intentes agredirlo, no lo confrontes verbalmente, ni corras.'
						url={sub2_act1_02}
						callback={() => {
							setUiToShow(steps.dialogNine);
						}}
					/>
				</>
			)}

			{uiToShow === steps.dialogNine && (
				<>
					<ModalInfoTextV3
						title='Menciona tus movimientos'
						description='Es importante comunicarle al delincuente de manera verbal que vamos a atender a sus peticiones, al entregarle algún bien o al realizar cualquier movimiento.'
						url={sub2_act1_03}
						callback={() => {
							setUiToShow(steps.dialogTen);
						}}
					/>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<ModalInfoTextV3
						title='No sigas al delincuente'
						description='Una vez que el delincuente se retire, ¡no lo persigas! Podría venir acompañado por algún cómplice y hacerte daño.'
						url={sub2_act1_04}
						callback={() => {
							setUiToShow(steps.dialogEleven);
						}}
					/>
				</>
			)}

			{uiToShow === steps.dialogEleven && (
				<>
					<ModalInfoTextV3
						title='Reporta'
						description='Después del suceso, trata de mantener la calma y reporta al Centro de Control de manera inmediata, para brindarte la asistencia que requieras.'
						url={sub2_act1_05}
						callback={() => {
							setUiToShow(steps.win);
						}}
					/>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Ahora conoces la Regla de Oro, asegurando tu seguridad en cualquier circunstancia peligrosa."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema8.activities.subtema2
								})
							);
							navigator("/home8/tema8/subtema2/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}
